import { isArray } from '@rehaje/shared'

import { SchemaModel } from '../../models/SchemaModel'

import type { SchemaVoidNode } from './TypedNode'

export class SchemaVoidModel extends SchemaModel {
  override get names() {
    return []
  }

  /**
   * @deprecated
   */
  get value() {
    return this.valuableParent?.value ?? undefined
  }

  override joinChildrenValuePath(child: SchemaModel) {
    if (this.parent) {
      return [...this.parent.valuePath, ...child.names]
    }
    return []
  }

  override render() {
    const node = this.getTypedNode<SchemaVoidNode>()
    return super.render(
      isArray(node.types)
        ? node.types.map((type) => type.render())
        : [node.types]
    )
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Void': SchemaVoidModel
  }
}
